import { GetSteps } from "ui/organisms/ReferenceTrack/ReferenceTrack";
import { referenceTrackDailyLivesMeterId } from "ui/organisms/ReferenceTrack/referenceTrackIds";
import { sharedReferenceTrackConfig } from "ui/templates/Game/sharedReferenceTrackConfig";

export const refrenceTrackIds = {
  playbackState: "playback-state",
  abPicker: "ab-picker",
};

export const referenceTrackSteps: GetSteps = ({ showAllSharedGameSteps }) => [
  showAllSharedGameSteps && {
    target: `#${refrenceTrackIds.playbackState}`,
    title: "Playback State",
    content: sharedReferenceTrackConfig.playbackState,
    placement: "auto",
  },
  {
    target: `#${refrenceTrackIds.abPicker}`,
    title: "Choose The Most Compressed",
    content: (
      <div>
        <ul className={"list-disc pl-4"}>
          <li>Click A if you think it is more compressed.</li>
          <li>Click B if you think it is more compressed.</li>
          <li>Click 'No Difference' if you think the sources are the same</li>
        </ul>
      </div>
    ),

    placement: "auto",
  },
  showAllSharedGameSteps && {
    target: `#${referenceTrackDailyLivesMeterId}`,
    title: "Daily Lives Meter",
    content: sharedReferenceTrackConfig.dailyLivesMeter,
  },
];
